const PARENT_PATHS = ['/preferences/'];

export const isLocationMatchingMenuItem = (menuItemLink: string, locationPathname: string) => {
  if (!PARENT_PATHS.find((el) => locationPathname.includes(el))) {
    return false;
  }
  return locationPathname.includes(menuItemLink);
};
